import { App } from 'vue'
import SvgIcon from './svg-icon.vue'

const req = (require as any).context('./icons', false, /\.svg$/)
const requireAll = (requireContext: any) => requireContext.keys().map(requireContext)
requireAll(req)
export default function install(app: App) {
  app.component(SvgIcon.name as string, SvgIcon)
}
